<template>
	<div class="text-center">
		<br />
		<b-spinner variant="secondary"></b-spinner>
		<br />
	</div>
</template>

<script>
export default {
	name: 'Spinner'
}

</script>


// WEBPACK FOOTER //
// src/components/common/Spinner.vue